class EmailVariantsList extends TableList {

  constructor(app, container, listRow, searchInputId = 'searchTable') {
    super(app, container, listRow, searchInputId)
    this.calendarId = calendarId;
    this.isRendering = true;
    app.observerManager = new ImageObserverManager(app, null, false);
  }

  static createIframe(row, centered = false) {
    let centeredHtml = row.emailHtml;
    if(centered) {
      // Option 2: Using Blob URL (if srcdoc is not supported)
      centeredHtml = `
        <html>
        <head>
            <style>
                body {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                    margin: 0;
                    zoom: 1.3;
                    font-family: Arial, sans-serif;
                }
            </style>
        </head>
        <body>
            ${row.emailHtml}
        </body>
        </html>
    `;
    }

    //Option 2: Using Blob URL (if srcdoc is not supported)
    const blob = new Blob([centeredHtml], {type: "text/html"});
    const blobUrl = URL.createObjectURL(blob);

    return `<div data-type="iframe" data-src="${blobUrl}" width="100%"  frameborder="0" scrolling="auto"></div>`;
  }

  static prepareRow(app, row, template) {
    let defaults = {
      emailsSent: this.staticPH,
      delivered: this.staticPH,
      open: this.staticPH,
      click: this.staticPH,
      bounce: this.staticPH,
      unsubscribe: this.staticPH,
      spamReport: this.staticPH,
      deliveredRate: this.staticPH,
      openRate: this.staticPH,
      clickRate: this.staticPH,
      bounceRate: this.staticPH,
      unsubscribeRate: this.staticPH,
      spamReportRate: this.staticPH
    };

    row = {...defaults, ...row};

    let card = _.template(app.templates[template]);

    row.emailHtml = EmailVariantsList.createIframe(row);

    const $card = $(card(row));

    let $images = $('.svg-object, .post-image', $card);
    $images.each(function (index, image) {
      if ($(image).attr('data-src') !== '') {
        app.observerManager.observeIntersection(image);
      }
    });

    let $iframes = $('[data-type="iframe"]', $card);
    $iframes.each(function (index, iframe) {
      if ($(iframe).attr('data-src') !== '') {
        app.observerManager.observeIntersection(iframe);
      }
    });
    return $card;
  }


  loaderData = {
    id: null,
    emailSubject: this.staticPH,
    emailsSent: this.staticPH,
    delivered: this.staticPH,
    open: this.staticPH,
    click: this.staticPH,
    bounce: this.staticPH,
    unsubscribe: this.staticPH,
    spamReport: this.staticPH,
    deliveredRate: this.staticPH,
    openRate: this.staticPH,
    clickRate: this.staticPH,
    bounceRate: this.staticPH,
    unsubscribeRate: this.staticPH,
    spamReportRate: this.staticPH,
    emailHtml: Utils.staticPHIframe,
  }

  processedLoaderData(overrideData = {}) {
    let data = this.loaderData;
    data = {...data, ...overrideData};
    return data;
  }

  async renderListByEmails(data) {
    return this.renderList(null, data);
  }

  static storeEmails(response) {
    const app = PreBuilt;

    window.calendarEmails = _.indexBy(response.emails, 'id');
    return response;
  }


  static async deleteCard(postId, container = '.tab-content-calendar') {
    this.updateCard({id: postId}, {id: postId}, true, container)
  }

  async renderList(calendarId, response) {
    this.isRendering = true;
    const self = this;
    const app = this.app;
    const $listContainer = this.container.empty();

    this.showLoader(this.processedLoaderData());

    if (app.localStorage.getItem('build-email-variants')) {
      const buildCampaign = JSON.parse(app.localStorage.getItem('build-email-variants'));
      app.localStorage.removeItem('build-email-variants');
      app.notify('success', 'Building emails for your campaign', true, {
        delay: 60000,
        allow_dismiss: false,
        type: 'dismissible alert-success top-50 text-center',
        placement: {from: 'top', align: 'center'}
      });

      try {
        response = await app.apis['mdcdot_email_variants'].build(buildCampaign.id);
        app.notifyEl.update({'message': response.message, progress: 100});
      } catch (e) {
        const message = `${e.code} :: ${e.message.message}`;
        app.notifyEl.update({type: 'dismissible alert-danger', message: message, progress: 90});
      }

    }

    this.response = response;

    this.removeLoader();

    if (!app.isEmpty(this.response.emails)) {
      this.response = EmailVariantsList.storeEmails(this.response);

      _.each(this.response.emails, function (event, index) {
        if (typeof event.deleted == 'undefined') {
          // show card footer
          event.cardFooter = true;
          event.swapButton = false;
          event.showMaximize = true;
          const $email = EmailVariantsList.prepareRow(self.app, event, self.listRow);
          $email.appendTo($listContainer);

        }
      });
    }

    app.initTooltip();

    this.isRendering = false;
    return response;
  }

  renderListByData(response) {
    this.isRendering = true;
    const self = this;
    const app = this.app;
    const $listContainer = this.container.empty();

    this.showLoader(this.processedLoaderData());

    this.removeLoader();

    this.response = response;

    _.each(response.emails, function (event, index) {
      if (typeof event.deleted == 'undefined') {
        // show card footer
        event.cardFooter = true;
        event.swapButton = false;
        event.showMaximize = true;
        const $email = EmailVariantsList.prepareRow(self.app, event, self.listRow);
        $email.appendTo($listContainer);
      }
    });

    app.initTooltip();

    this.isRendering = false;
    return response;
  }

  setData (data) {
    this.response = data;
  }

  async renderTableView ($tableContainer, listRow) {
    this.isRendering = true;
    const self = this;
    const app = this.app;
    let table = _.template(app.templates['dot_email__variants-table']);
    let $table = $(table());
    $table.appendTo($tableContainer);
    let $tbody = $table.find('tbody');

    if (!app.isEmpty(this.response.emails)) {
      _.each(this.response.emails, function (event, index) {
        if (typeof event.deleted == 'undefined') {
          const $email = EmailVariantsList.prepareRow(self.app, event, listRow);
          $email.appendTo($tbody);
        }
      });
    }

    this.isRendering = false;
  }


  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}

 function previewEmailVariant(emailVariantId,aimiEmailCampaignId =0 ,leadId = 0) {

  const app = PreBuilt;

  const $modal = app.infoModal('Email Preview', `<iframe class="email-preview"  src="/api/mdcdot/lead/${leadId}/email-variant/${aimiEmailCampaignId}/${emailVariantId}" > </iframe>`, {dialogClass: 'modal-lg modal-dialog-scrollable modal-email-preview'});

  // Get the object element
  let objectElement = document.querySelector('.email-preview');

  // Listen for the onload event
  objectElement.onload = function () {
    progress.remove();
    objectElement.classList.add('loaded');
  };

  const progress = new ProgressBar($modal.find('.modal-body'));
  progress.start();
}